import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a5c879c2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "editor-form-dropdown-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ProsemirrorViewerFormOption = _resolveComponent("ProsemirrorViewerFormOption");
    const _component_FriedIcon = _resolveComponent("FriedIcon");
    const _component_FriedFieldSet = _resolveComponent("FriedFieldSet");
    const _component_FriedDropdown = _resolveComponent("FriedDropdown");
    const _directive_tooltip = _resolveDirective("tooltip");
    return (_openBlock(), _createBlock(_component_FriedDropdown, {
        "same-width-as-ref": true,
        "append-to-body": true,
        onKeyUp: _ctx.handleKeyUp,
        onKeyDown: _ctx.handleKeyDown,
        onKeyEnter: _ctx.handleKeyEnter,
        onSelect: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('update-selected', _ctx.input.inputSettings.options[_ctx.selectedIndex])))
    }, {
        trigger: _withCtx(({ open }) => [
            _createVNode(_component_FriedFieldSet, {
                id: _ctx.input.id,
                "data-external": "form-input-dropdown-input-view",
                disabled: _ctx.isDisabled,
                tabindex: 0,
                class: "dropdown-option-box",
                error: _ctx.hasUpdateError,
                onKeyup: _ctx.preventOpenIfDisabled,
                onKeydown: [
                    _cache[0] || (_cache[0] = _withKeys(_withModifiers(() => { }, ["prevent"]), ["up"])),
                    _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => { }, ["prevent"]), ["down"]))
                ],
                onClick: _ctx.preventOpenIfDisabled
            }, {
                default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_ProsemirrorViewerFormOption, {
                        class: "select-option-button",
                        content: _ctx.getDropdownValueContent(_ctx.input, _ctx.fields, _ctx.recipientInput),
                        "merge-values": _ctx.mergeValues,
                        fields: _ctx.fields,
                        "is-updating": _ctx.isUpdating
                    }, null, 8, ["content", "merge-values", "fields", "is-updating"]), [
                        [_directive_tooltip, _ctx.tooltip]
                    ]),
                    _createElementVNode("div", {
                        class: _normalizeClass(['select-chevron', { open }])
                    }, [
                        _createVNode(_component_FriedIcon, { icon: "chevron-down" })
                    ], 2)
                ]),
                _: 2
            }, 1032, ["id", "disabled", "error", "onKeyup", "onClick"])
        ]),
        content: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.input.inputSettings.options, (option, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: 'option' + index + option,
                        class: "items-container"
                    }, [
                        (_ctx.showDropdownOption(option))
                            ? (_openBlock(), _createBlock(_component_ProsemirrorViewerFormOption, {
                                key: 0,
                                class: _normalizeClass(['select-option-item', { selected: _ctx.selectedIndex === index }]),
                                content: _ctx.getInputContent(option, _ctx.fields),
                                "merge-values": _ctx.mergeValues,
                                fields: _ctx.fields,
                                onMouseover: ($event) => (_ctx.isScrolling || (_ctx.selectedIndex = index)),
                                onMousedown: _withModifiers(($event) => (_ctx.$emit('update-selected', option)), ["stop"])
                            }, null, 8, ["class", "content", "merge-values", "fields", "onMouseover", "onMousedown"]))
                            : _createCommentVNode("", true)
                    ]));
                }), 128))
            ])
        ]),
        _: 1
    }, 8, ["onKeyUp", "onKeyDown", "onKeyEnter"]));
}
